module.exports = __webpack_public_path__ + "img/back_4.70ece7ed.svg";